// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kHpla","inner":"Footer_inner__vaShd","left":"Footer_left__i2w2L","right":"Footer_right__i-lF3"};